/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filters_TitleInputs */



/**
* | output |
* | --- |
* | "Filters" |
*
* @param {Filters_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const filters_title = /** @type {((inputs?: Filters_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filters_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Filtres")
	if (locale === "es") return /** @type {LocalizedString} */ ("Filtros")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Filtros")
	if (locale === "it") return /** @type {LocalizedString} */ ("Filtri")
	return /** @type {LocalizedString} */ ("Filters")
});